import { SettingsLayout as Settings } from '../../components';

export function SettingsLayout() {
  return <Settings />;
}
